import { useEffect, useState } from 'react';
import { messaging } from 'helpers/firebase';
import { onMessage, isSupported } from 'firebase/messaging';
import { toast } from 'react-toastify';
import useFCMToken from 'hooks/useFCMToken';

const useFCM = () => {
  const { fcmToken, loading } = useFCMToken();
  const [messages, setMessages] = useState([]);
  useEffect(() => {
    const isSupportedBrowser = isSupported();
    if (isSupportedBrowser) {
      const fcmmessaging = messaging();
      const unsubscribe = onMessage(fcmmessaging, (payload) => {
        toast.dark(payload.notification?.title);
        setMessages((messages) => [...messages, payload]);
      });
      return () => unsubscribe();
    }
  }, [fcmToken]);
  return { fcmToken, loading, messages };
};

export default useFCM;
